import Footer from '@components/organisms/FooterNew'
import Header from '@components/organisms/Header/Header'
import HeroSection from '@components/pages/referrals-landing/HeroSection'
import InviteNow from '@components/pages/referrals-landing/InviteNow'
// import { colors } from '@configs/styles/config'
import styled from '@emotion/styled'
import { useDisclosure } from '@nextui-org/react-latest'
// import ClockIcon from '@public/static/icons/referrals-landing/clockIcon'
// import EarnIllustration from '@public/static/icons/referrals-landing/earnIllustration'
// import InviteIllustration from '@public/static/icons/referrals-landing/inviteIllustration'
// import TrackIllustration from '@public/static/icons/referrals-landing/trackIllustration'
// import WithdrawalIcon from '@public/static/icons/referrals-landing/withdrawalIcon'
// import WorldIcon from '@public/static/icons/referrals-landing/worldIcon'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Head from 'next/head'
import { useEffect, useState } from 'react'
const JoinReferralForm = dynamic(
  () =>
    import('@components/pages/referrals-landing/components/JoinReferralForm'),
  { ssr: false }
)
// const ReferralsAbout = dynamic(
//   () => import('@components/pages/referrals-landing'),
//   { ssr: false }
// )

import { useTranslation } from 'next-i18next'
import { useAuth } from '@contexts/Auth'
import { useRouter } from 'next/router'
import FAQSection from '@components/pages/advantageous/FAQSection'
import dynamic from 'next/dynamic'
import ReferralsAbout from '@components/pages/referrals-landing'
import withLenis from '@components/HOCs/LenisWrapper'

type Props = {}

export async function getServerSideProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
        'authentication',
        'footer',
        'signUp',
        'wishlist',
        'cartModal',
        'wishlistDropdown',
        'errors',
        'referrals',
        'reportProblem',
      ])),
    },
  }
}

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const ChildWrapper = styled.div`
  @media screen and (max-width: 1525px) {
    padding: 0px 0.8rem;
  }
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
// const ItemTitle = styled.div`
//   font-family: var(--font-roboto);
//   font-size: 18px;
//   font-weight: 500;
//   line-height: 23.4px;
//   text-align: left;
//   text-underline-position: from-font;
//   text-decoration-skip-ink: none;
//   color: ${colors.uguPurple};
// `

const ReferralLandingPage = ({}: Props) => {
  const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure()
  const { t, i18n } = useTranslation('referrals')
  const {
    setShowAuthModal,
    isAuthenticated,
    showUserDetailModal,
    isAuthLoading,
  } = useAuth()
  const [wasAboutToJoin, setWasAboutToJoin] = useState(false)
  const [isJoined, setIsJoined] = useState(false)
  const router = useRouter()

  // const withdrawalItems = [
  //   {
  //     title: 'Automatic withdrawal',
  //     icon: <WithdrawalIcon />,
  //   },
  //   {
  //     title: 'All over the globe',
  //     icon: <WorldIcon />,
  //   },
  //   {
  //     title: 'Available at any time',
  //     icon: <ClockIcon />,
  //   },
  // ]

  useEffect(() => {
    if (wasAboutToJoin) {
      if (showUserDetailModal) onClose()
      else if (isAuthenticated) onOpen()
    }
  }, [isAuthenticated, showUserDetailModal])

  useEffect(() => {
    if (router.query?.type === 'join') {
      if (isAuthLoading) return
      handleOpenJoinReferralModal()
    }
  }, [router, isAuthLoading])

  const handleOpenJoinReferralModal = (isShare = false) => {
    if (!isAuthenticated) {
      setShowAuthModal(true)

      setWasAboutToJoin(true)
    } else {
      if (isJoined)
        router.push(`/referrals/dashboard/${isShare ? '?shareCode=true' : ''}`)
      else onOpen()
    }
  }

  return (
    <>
      <Head>
        <title>{t('landingPageTitle')}</title>
        <meta name="og:title" content={t('landingPageTitle')} />
        <meta name="description" content={t('invite_and_earn_description')} />
        <meta
          name="og:description"
          content={t('invite_and_earn_description')}
        />
        <link rel="canonical" href={`https://www.edugram.io/referrals/`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t('landingPageTitle')} />
        <meta
          name="twitter:description"
          content={t('invite_and_earn_description')}
        />
        <meta property="og:type" content="video_lecture" />
        <meta property="og:site_name" content="Edugram.io" />
        <meta property="og:locale" content={i18n.language} />
        <meta name="twitter:domain" content="www.edugram.io" />
        <meta
          name="keywords"
          content={
            'Referrals, Referrer Edugram, Edugram.io, education, courses, learning, resources, skills, online learning, personalized learning, career coaching, personal development, skill development, professional development, '
          }
        />
      </Head>
      <MainWrapper>
        <ChildWrapper>
          <Header />
        </ChildWrapper>
        <BodyWrapper>
          <HeroSection />
          <ReferralsAbout
            handleOpenJoinReferralModal={handleOpenJoinReferralModal}
            isJoined={isJoined}
          />
          <FAQSection i18NameSpace="referrals" />
          <InviteNow onBtnClick={() => handleOpenJoinReferralModal(true)} />
          <JoinReferralForm
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            setIsJoined={setIsJoined}
          />
        </BodyWrapper>
        <ChildWrapper className="px-2 lg:px-5">
          <Footer />
        </ChildWrapper>
      </MainWrapper>
    </>
  )
}

export default withLenis(ReferralLandingPage)
